module.exports = __webpack_public_path__ + "static/img/SC12.d99f07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC12.jpg
// module id = 3q9+
// module chunks = 0